import {
  type Post,
  type PostTileAsset,
} from "@package/ui-gql/index-data-access";

export type PostTileAssetWithPost = {
  id: string;
  asset: PostTileAsset;
  post: Post;
  relatedPosts: Post[];
};

export class ProfileLayoutModelManager {
  private hashes: string[] = [];

  public add(asset: PostTileAssetWithPost) {
    this.hashes.push(getPostTileAssetHash(asset));
  }

  public delete(asset: PostTileAssetWithPost) {
    const hash = getPostTileAssetHash(asset);
    const index = this.hashes.indexOf(hash);
    if (index > -1) {
      this.hashes.splice(index, 1);
    }
  }

  public has(asset: PostTileAssetWithPost) {
    return this.hashes.includes(getPostTileAssetHash(asset));
  }
}

function getPostTileAssetHash(asset: PostTileAssetWithPost): string {
  try {
    return JSON.stringify(asset);
  } catch (e) {
    console.error("[wall-manager-profile]: getPostTileAssetHash", e);
  }

  return "";
}
